import React from 'react';
import { AvInput, AvGroup as BaseAvGroup } from 'availity-mobx-reactstrap-validation';
import { formatCurrency } from 'js/services/Format';
import styled from 'styled-components';

const MoneySign = styled(props => <span {...props}>{formatCurrency().replace('NaN', '')}</span>)`
  position: absolute;
  left: 0;
  width: 2rem;
  text-align: center;
  font-size: 1.5rem;
  font-weight: bold;
  line-height: 2.5rem;
`;

const AvGroup = styled(BaseAvGroup)`
  && {
    margin: 0;
  }
`;

const MoneyInput = styled(AvInput)`
  padding-left: 2rem;
  height: 3rem;
  font-size: 1.3rem;
  font-weight: 500;
  text-align: right;
  border-bottom-right-radius: 0;
  border-bottom-left-radius: 0;
`;


export default props => (
  <AvGroup>
    {/*<MoneySign />*/}
    <MoneyInput {...props} />
  </AvGroup>
);
